<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const { getNuxtLink, isExternal } = useCustomLink()
// props
defineProps({
  mapList: {
    type: Array,
    default: () => []
  },
  mapArea: {
    type: String,
    default: () => ''
  },
  mapTitle: {
    type: String,
    default: () => '服装予報'
  },
  type: {
    type: String,
    required: true }
})
</script>

<template>
  <section
    class="clothesMap"
    :data-type="type"
  >
    <SectionTitle :title="mapTitle" />
    <div class="map">
      <figure
        class="image"
        style="width: 100%; padding-top: 59%; background-color: #E4E5E9; position: relative; margin-left: auto; margin-right: auto;"
      >
        <img
          style="left: 0px; top: 0px; position: absolute; z-index: 1; width: 100%; max-width: 100%;"
          :src="`https://gvs.weathernews.jp/clothes/images/map/map_${mapArea}.webp`"
          alt="エリアマップ"
        >
      </figure>
      <NuxtLink
        v-for="link in mapList"
        :key="link.key"
        :to="getNuxtLink(link.link)"
        :external="isExternal(link.link)"
        :data-area="link.key"
        :class="[{ 'sp-only': link.isSP && !link.isPC }, { 'pc-only': !link.isSP && link.isPC }, 'link']"
      >
        <p class="area">
          {{ link.name }}
        </p>
        <span class="arrow" />
        <div
          v-if="link?.icon?.daytime && link?.icon?.asaban"
          class="balloon"
        >
          <div class="column">
            <figure class="head day">
              <span>昼間</span>
              <img
                src="https://gvs.weathernews.jp/clothes/images/icon/icon_day.svg"
                width="13"
                height="14"
                loading="lazy"
              >
            </figure>
            <figure class="body">
              <img
                :src="link?.icon?.daytime"
                width="30"
                height="25"
                loading="lazy"
              >
            </figure>
          </div>
          <div class="column">
            <figure class="head night">
              <span>朝晩</span>
              <img
                src="https://gvs.weathernews.jp/clothes/images/icon/icon_night.svg"
                width="24"
                height="12"
                loading="lazy"
              >
            </figure>
            <figure class="body">
              <img
                :src="link?.icon?.asaban"
                width="30"
                height="25"
                loading="lazy"
              >
            </figure>
          </div>
        </div>
      </Nuxtlink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.clothesMap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .map {
    position: relative;
    margin-inline: -10px;
  }
  .date {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1.33vw;
    border-bottom-left-radius: 10px;
    border-bottom: 3px solid #FFF;
    border-left: 3px solid #FFF;
    background-color: #819BC7;
    z-index: 2;
    &[data-date="tommorrow"] {
      background-color: #75B1D7;
    }
    p {
      color: #fff;
      font-size: 4.27vw;
      font-weight: 500;
      line-height: 1em;
    }
  }
  .image {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
  .link {
    z-index: 10;
    display: flex;
    align-items: stretch;
    position: absolute;
    border-radius: 100vmax;
    border: 2px solid #3569C0;
    background-color: #3569C0;
    box-shadow: 2px 2px 1px 0 rgb(0 0 0 / .25);
    .area {
      padding: 1.33vw 2.67vw;
      background-color: #fff;
      border-top-left-radius: 3.47vw;
      border-bottom-left-radius: 3.47vw;
      color: #3569C0;
      font-size: 4.27vw;
      font-weight: 500;
      line-height: 1em;
      user-select: none;
    }
    .arrow {
      width: 5.33vw;
      background-image: url("https://gvs.weathernews.jp/clothes/images/icon/icon_arrow.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 2.67vw;
    }
    .balloon {
      position: absolute;
      display: flex;
      background-color: #fff;
      border-radius: 5px;
      top: -15.47vw;
      left: 50%;
      margin-left: -12vw;
      filter: drop-shadow(2px 2px 1px rgb(0 0 0 / .25));
      z-index: 2;
      &::before {
        position: absolute;
        top: 99%;
        right: 10%;
        width: 4.53vw;
        height: 3.2vw;
        background-color: #fff;
        clip-path: polygon(16% 0, 0% 100%, 100% 0);
        content: '';
      }
      .column {
        width: 12vw;
        &:last-child {
          .head {
            border-left: solid 1px #fff;
          }
          .body {
            border-left: solid 1px #F5F5F5;
          }
        }
      }
      .head {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .8vw .27vw;
        gap: .27vw;
        height: 4.8vw;
        &.day {
          border-top-left-radius: 5px;
          background-color: #F7F7E9;
        }
        &.night {
          border-top-right-radius: 5px;
          background-color: #EEF1F8;
        }
        img {
          width: auto;
          height: 100%;
        }
        span {
          color: #303030;
          font-size: 2.67vw;
          line-height: 1em;
          user-select: none;
        }
      }
      .body {
        padding: .8vw 1.33vw;
        height: 8.53vw;
        text-align: center;
        img {
          width: auto;
          height: 100%;
        }
      }
    }
    // hokkaido
    &[data-area="hokkaido"] {
      top: 9%;
      right: 35%;
    }
    // douou
    &[data-area="douou"] {
      top: 47%;
      left: 32%;
    }
    &[data-area="sapporo"] {
      top: 53%;
      left: 35%;
    }
    &[data-area="suttsu"] {
      bottom: 5%;
      left: 5%;
    }
    &[data-area="fukagawa"] {
      top: 28%;
      right: 17%;
    }
    // dounan
    &[data-area="dounan"] {
      top: 79%;
      left: 12%;
    }
    &[data-area="hakodate"] {
      bottom: 9%;
      left: 11%;
    }
    &[data-area="urakawa"] {
      bottom: 45%;
      right: 5%;
    }
    &[data-area="tomakomai"] {
      bottom: 56%;
      left: 39%;
    }
    // douhoku
    &[data-area="douhoku"] {
      top: 11%;
      left: 46%;
    }
    &[data-area="asahikawa"] {
      bottom: 5%;
      left: 51%;
    }
    &[data-area="wakkanai"] {
      top: 28%;
      left: 42%;
    }
    &[data-area="rumoi"] {
      bottom: 35%;
      left: 14%;
    }
    // doutou
    &[data-area="doutou"] {
      top: 39%;
      right: 21%;
    }
    &[data-area="kushiro"] {
      bottom: 8%;
      right: 17%;
    }
    &[data-area="obihiro"] {
      bottom: 30%;
      left: 20%;
    }
    &[data-area="abashiri"] {
      top: 28%;
      right: 25%;
    }
    // tohoku
    &[data-area="tohoku"] {
      top: 32%;
      right: 16%;
    }
    // aomori
    &[data-area="aomori"] {
      top: 9%;
      right: 36%;
      &:is([data-type="pref"] *) {
        top: auto;
        bottom: 40%;
        right: 39%;
      }
    }
    &[data-area="hirosaki"] {
      bottom: 27%;
      left: 13%;
    }
    &[data-area="hachinohe"] {
      bottom: 21%;
      right: 13%;
    }
    // akita
    &[data-area="akita"] {
      top: 38%;
      left: 30%;
      &:is([data-type="pref"] *) {
        top: 47%;
        left: 19%;
      }
    }
    &[data-area="odate"] {
      top: 27%;
      left: 51%;
    }
    &[data-area="yokote"] {
      bottom: 11%;
      right: 32%;
    }
    // iwate
    &[data-area="iwate"] {
      top: 36%;
      right: 21%;
    }
    &[data-area="morioka"] {
      top: 36%;
      left: 29%;
    }
    &[data-area="miyako"] {
      top: 42%;
      right: 11%;
    }
    &[data-area="ichinoseki"] {
      top: 79%;
      right: 34%;
    }
    // yamagata
    &[data-area="yamagata"] {
      top: 56%;
      left: 28%;
      &:is([data-type="pref"] *) {
        top: 75%;
        left: auto;
        right: 23%;
      }
    }
    &[data-area="sakata"] {
      top: 28%;
      left: 19%;
    }
    &[data-area="yonezawa"] {
      bottom: 5%;
      left: 27%;
    }
    &[data-area="shinjo"] {
      top: 34%;
      right: 35%;
    }
    // miyagi
    &[data-area="miyagi"] {
      top: 62%;
      right: 23%;
    }
    &[data-area="sendai"] {
      top: 38%;
      left: 39%;
    }
    &[data-area="shiroishi"] {
      top: 79%;
      left: 22%;
    }
    &[data-area="kesennuma"] {
      top: 28%;
      right: 13%;
    }
    // fukushima
    &[data-area="fukushima"] {
      bottom: 8%;
      left: 33%;
      &:is([data-type="pref"] *) {
        bottom: 58%;
        left: 42%;
      }
    }
    &[data-area="iwaki"] {
      bottom: 15%;
      right: 10%;
    }
    &[data-area="aizuwakamatsu"] {
      bottom: 21%;
      left: 14%;
    }
    // kanto
    &[data-area="kanto"] {
      top: 59%;
      right: 20%;
    }
    // tokyo
    &[data-area="tokyo"] {
      &:is([data-type="area"] *) {
        top: 52%;
        left: 39%;
        right: auto;
      }
      &:is([data-type="pref"] *) {
        top: 71%;
        right: 5%;
      }
    }
    &[data-area="nerima"] {
      top: 30%;
      right: 30%;
    }
    &[data-area="hachiouji"] {
      top: 56%;
      left: 19%;
    }
    // kanagawa
    &[data-area="kanagawa"] {
      top: 78%;
      left: 28%;
    }
    &[data-area="yokohama"] {
      top: 41%;
      right: 11%;
    }
    &[data-area="hakone"] {
      top: 66%;
      left: 9%;
    }
    &[data-area="atsugi"] {
      top: 45%;
      left: 38%;
    }
    // chiba
    &[data-area="chiba"] {
      top: 67%;
      right: 19%;
      &:is([data-type="pref"] *) {
        top: 40%;
        right: 53%;
      }
    }
    &[data-area="tateyama"] {
      bottom: 4%;
      right: 32%;
    }
    &[data-area="choshi"] {
      top: 33%;
      right: 17%;
    }
    // saitama
    &[data-area="saitama"] {
      top: 40%;
      left: 16%;
      &:is([data-type="pref"] *) {
        top: 53%;
        left: auto;
        right: 3%;
      }
    }
    &[data-area="chichibu"] {
      top: 52%;
      left: 7%;
    }
    &[data-area="kumagaya"] {
      top: 30%;
      right: 40%;
    }
    // tochigi
    &[data-area="tochigi"] {
      top: 12%;
      right: 28%;
    }
    &[data-area="utsunomiya"] {
      top: 70%;
      right: 32%;
    }
    &[data-area="nasushiobara"] {
      top: 29%;
      right: 16%;
    }
    &[data-area="nikko"] {
      top: 42%;
      left: 20%;
    }
    // gunma
    &[data-area="gunma"] {
      top: 19%;
      left: 23%;
    }
    &[data-area="maebashi"] {
      top: 72%;
      left: 33%;
    }
    &[data-area="tatebayashi"] {
      top: 69%;
      right: 10%;
    }
    &[data-area="minakami"] {
      top: 29%;
      left: 23%;
    }
    // ibaraki
    &[data-area="ibaraki"] {
      top: 36%;
      right: 23%;
    }
    &[data-area="mito"] {
      top: 48%;
      right: 25%;
    }
    &[data-area="daigo"] {
      top: 28%;
      left: 27%;
    }
    &[data-area="tsuchiura"] {
      top: 80%;
      left: 29%;
    }
    // chubu
    &[data-area="chubu"] {
      top: 43%;
      left: 36%;
    }
    // aichi
    &[data-area="aichi"] {
      top: 80%;
      left: 42%;
    }
    &[data-area="nagoya"] {
      top: 31%;
      left: 10%;
    }
    &[data-area="toyohashi"] {
      bottom: 5%;
      right: 13%;
    }
    &[data-area="okazaki"] {
      top: 51%;
      left: 41%;
    }
    // shizuoka
    &[data-area="shizuoka"] {
      top: 66%;
      right: 16%;
      &:is([data-type="pref"] *) {
        top: 51%;
        right: 42%;
      }
    }
    &[data-area="hamamatsu"] {
      top: 59%;
      left: 11%;
    }
    &[data-area="gotenba"] {
      top: 31%;
      right: 13%;
    }
    // gifu
    &[data-area="gifu"] {
      top: 40%;
      left: 25%;
      &:is([data-type="pref"] *) {
        top: 72%;
        left: 32%;
      }
    }
    &[data-area="takayama"] {
      top: 29%;
      right: 25%;
    }
    &[data-area="nakatsugawa"] {
      top: 75%;
      right: 11%;
    }
    // yamanashi
    &[data-area="yamanashi"] {
      top: 47%;
      right: 19%;
    }
    &[data-area="kofu"] {
      top: 32%;
      right: 39%;
    }
    &[data-area="minobu"] {
      top: 74%;
      left: 20%;
    }
    &[data-area="otsuki"] {
      top: 47%;
      right: 11%;
    }
    // nagano
    &[data-area="nagano"] {
      top: 59%;
      left: 39%;
      &:is([data-type="pref"] *) {
        top: 27%;
        left: 45%;
      }
    }
    &[data-area="matsumoto"] {
      top: 47%;
      left: 19%;
    }
    &[data-area="iida"] {
      top: 72%;
      right: 34%;
    }
    // niigata
    &[data-area="niigata"] {
      top: 15%;
      right: 13%;
      &:is([data-type="pref"] *) {
        top: 37%;
        right: 43%;
      }
    }
    &[data-area="joetsu"] {
      top: 80%;
      left: 18%;
    }
    &[data-area="murakami"] {
      top: 27%;
      right: 17%;
    }
    // toyama
    &[data-area="toyama"] {
      top: 29%;
      left: 48%;
      &:is([data-type="pref"] *) {
        top: 60%;
        left: 52%;
      }
    }
    &[data-area="himi"] {
      top: 27%;
      left: 22%;
    }
    &[data-area="tonami"] {
      top: 69%;
      left: 25%;
    }
    // ishikawa
    &[data-area="ishikawa"] {
      top: 18%;
      left: 22%;
    }
    &[data-area="kanazawa"] {
      top: 67%;
      right: 27%;
    }
    &[data-area="wajima"] {
      top: 28%;
      left: 31%;
    }
    &[data-area="kaga"] {
      top: 81%;
      left: 17%;
    }
    // fukui
    &[data-area="fukui"] {
      top: 57%;
      left: 10%;
      &:is([data-type="pref"] *) {
        top: 28%;
        left: 31%;
      }
    }
    &[data-area="tsuruga"] {
      top: 75%;
      left: 27%;
    }
    &[data-area="ono"] {
      top: 43%;
      right: 13%;
    }
    // mie
    &[data-area="mie"] {
      top: 75%;
      left: 19%;
    }
    &[data-area="tsu"] {
      top: 37%;
      left: 36%;
    }
    &[data-area="yokkaichi"] {
      top: 28%;
      right: 14%;
    }
    &[data-area="owase"] {
      bottom: 8%;
      left: 23%;
    }
    // kinki
    &[data-area="kinki"] {
      top: 75%;
      left: 44%;
    }
    // osaka
    &[data-area="osaka"] {
      bottom: 43%;
      left: 27%;
      &:is([data-type="pref"] *) {
        bottom: 45%;
        left: 29%;
      }
    }
    &[data-area="hirakata"] {
      top: 29%;
      right: 20%;
    }
    &[data-area="kishiwada"] {
      bottom: 3%;
      left: 44%;
    }
    // kyoto
    &[data-area="kyoto"] {
      top: 7%;
      left: 40%;
      &:is([data-type="pref"] *) {
        top: 40%;
        left: 51%;
      }
    }
    &[data-area="maizuru"] {
      top: 28%;
      left: 22%;
    }
    &[data-area="uji"] {
      top: 84%;
      right: 21%;
    }
    // hyogo
    &[data-area="hyogo"] {
      top: 23%;
      left: 13%;
    }
    &[data-area="kobe"] {
      top: 78%;
      right: 21%;
    }
    &[data-area="toyooka"] {
      top: 32%;
      right: 29%;
    }
    &[data-area="himeji"] {
      top: 69%;
      left: 30%;
    }
    // nara
    &[data-area="nara"] {
      bottom: 29%;
      left: 54%;
      &:is([data-type="pref"] *) {
        bottom: 59%;
        left: 43%;
      }
    }
    &[data-area="totsukawa"] {
      bottom: 3%;
      left: 17%;
    }
    &[data-area="yoshino"] {
      top: 69%;
      right: 29%;
    }
    // wakayama
    &[data-area="wakayama"] {
      bottom: 14%;
      left: 20%;
      &:is([data-type="pref"] *) {
        bottom: 58%;
        left: 12%;
      }
    }
    &[data-area="shingu"] {
      top: 63%;
      right: 19%;
    }
    &[data-area="shirahama"] {
      top: 75%;
      left: 29%;
    }
    // shiga
    &[data-area="shiga"] {
      top: 24%;
      right: 19%;
    }
    &[data-area="otsu"] {
      top: 64%;
      left: 15%;
    }
    &[data-area="hikone"] {
      top: 77%;
      right: 30%;
    }
    &[data-area="maibara"] {
      top: 31%;
      right: 22%;
    }
    // chugoku
    &[data-area="chugoku"] {
      top: 57%;
      left: 20%;
    }
    // hiroshima
    &[data-area="hiroshima"] {
      top: 64%;
      left: 36%;
      &:is([data-type="pref"] *) {
        top: 54%;
        left: 22%;
      }
    }
    &[data-area="shobara"] {
      top: 29%;
      right: 26%;
    }
    &[data-area="onomichi"] {
      top: 75%;
      right: 28%;
    }
    // okayama
    &[data-area="okayama"] {
      top: 58%;
      right: 15%;
      &:is([data-type="pref"] *) {
        top: 69%;
        right: 34%;
      }
    }
    &[data-area="tsuyama"] {
      top: 28%;
      right: 30%;
    }
    &[data-area="niimi"] {
      top: 35%;
      left: 18%;
    }
    // yamaguchi
    &[data-area="yamaguchi"] {
      top: 64%;
      left: 4%;
      &:is([data-type="pref"] *) {
        top: 71%;
        left: 43%;
      }
    }
    &[data-area="hagi"] {
      top: 28%;
      left: 34%;
    }
    &[data-area="shimonoseki"] {
      top: 54%;
      left: 8%;
    }
    // tottori
    &[data-area="tottori"] {
      top: 28%;
      right: 10%;
      &:is([data-type="pref"] *) {
        top: 37%;
        right: 14%;
      }
    }
    &[data-area="yonago"] {
      top: 30%;
      left: 11%;
    }
    &[data-area="kurayoshi"] {
      top: 55%;
      left: 39%;
    }
    // shimane
    &[data-area="shimane"] {
      top: 39%;
      left: 23%;
    }
    &[data-area="matsue"] {
      top: 70%;
      right: 23%;
    }
    &[data-area="hamada"] {
      top: 70%;
      left: 20%;
    }
    &[data-area="oki"] {
      top: 28%;
      left: 33%;
    }
    // shikoku
    &[data-area="shikoku"] {
      top: 87%;
      left: 23%;
    }
    // ehime
    &[data-area="ehime"] {
      top: 38%;
      left: 15%;
    }
    &[data-area="matsuyama"] {
      top: 32%;
      left: 37%;
    }
    &[data-area="uwajima"] {
      top: 77%;
      left: 15%;
    }
    &[data-area="niihama"] {
      top: 55%;
      right: 14%;
    }
    // kagawa
    &[data-area="kagawa"] {
      top: 13%;
      right: 32%;
    }
    &[data-area="takamatsu"] {
      top: 75%;
      right: 37%;
    }
    &[data-area="kotohira"] {
      top: 73%;
      left: 10%;
    }
    &[data-area="shodoshima"] {
      top: 27%;
      right: 36%;
    }
    // tokushima
    &[data-area="tokushima"] {
      top: 33%;
      right: 18%;
      &:is([data-type="pref"] *) {
        top: 35%;
        right: 14%;
      }
    }
    &[data-area="minami"] {
      top: 81%;
      right: 19%;
    }
    &[data-area="mima"] {
      top: 38%;
      left: 34%;
    }
    // kouchi
    &[data-area="kouchi"] {
      top: 61%;
      left: 34%;
      &:is([data-type="pref"] *) {
        top: 30%;
        left: 42%;
      }
    }
    &[data-area="sukumo"] {
      top: 69%;
      left: 8%;
    }
    &[data-area="muroto"] {
      top: 50%;
      right: 7%;
    }
    // kyushu
    &[data-area="kyushu"] {
      top: 72%;
      left: 5%;
    }
    // fukuoka
    &[data-area="fukuoka"] {
      top: 6%;
      right: 28%;
      &:is([data-type="pref"] *) {
        top: 36%;
        right: 49%;
      }
    }
    &[data-area="kokura"] {
      top: 28%;
      right: 20%;
    }
    &[data-area="kurume"] {
      top: 79%;
      left: 46%;
    }
    // saga
    &[data-area="saga"] {
      top: 15%;
      left: 30%;
      &:is([data-type="pref"] *) {
        top: 53%;
        left: 61%;
      }
    }
    &[data-area="karatsu"] {
      top: 27%;
      left: 37%;
    }
    &[data-area="imari"] {
      top: 68%;
      left: 16%;
    }
    // nagasaki
    &[data-area="nagasaki"] {
      top: 31%;
      left: 20%;
      &:is([data-type="pref"] *) {
        top: 83%;
        left: 21%;
      }
    }
    &[data-area="sasebo"] {
      top: 61%;
      right: 27%;
    }
    &[data-area="tsushima"] {
      top: 28%;
      left: 13%;
    }
    // oita
    &[data-area="oita"] {
      top: 25%;
      right: 19%;
      &:is([data-type="pref"] *) {
        top: 31%;
        right: 29%;
      }
    }
    &[data-area="hita"] {
      top: 38%;
      left: 11%;
    }
    &[data-area="saiki"] {
      bottom: 9%;
      right: 16%;
    }
    // kumamoto
    &[data-area="kumamoto"] {
      top: 47%;
      left: 31%;
      &:is([data-type="pref"] *) {
        top: 37%;
        left: 32%;
      }
    }
    &[data-area="aso"] {
      top: 29%;
      right: 17%;
    }
    &[data-area="hitoyoshi"] {
      bottom: 6%;
      right: 34%;
    }
    // miyazaki
    &[data-area="miyazaki"] {
      top: 55%;
      right: 25%;
      &:is([data-type="pref"] *) {
        top: 75%;
        right: 29%;
      }
    }
    &[data-area="nobeoka"] {
      top: 28%;
      right: 18%;
    }
    &[data-area="takachiho"] {
      top: 31%;
      left: 27%;
    }
    // kagoshima
    &[data-area="kagoshima"] {
      top: 77%;
      left: 23%;
      &:is([data-type="pref"] *) {
        top: 34%;
        left: 23%;
      }
    }
    &[data-area="kanoya"] {
      top: 53%;
      right: 21%;
    }
    &[data-area="amami"] {
      bottom: 5%;
      left: 5%;
    }
    // okinawa
    &[data-area="okinawa"] {
      top: 14%;
      left: 7%;
    }
    &[data-area="naha"] {
      top: 41%;
      left: 38%;
    }
    &[data-area="nago"] {
      top: 42%;
      right: 13%;
    }
    &[data-area="miyakojima"] {
      top: 83%;
      left: 30%;
    }
    &[data-area="ishigaki"] {
      top: 59%;
      left: 3%;
    }
  }
  .legend {
    margin-left: auto;
    padding-left: 20px;
    background-image: url("https://gvs.weathernews.jp/clothes/images/icon/icon_legend.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 15px;
    color: #3569c0;
    line-height: 1em;
    text-decoration: underline;
  }
  @media (any-hover: hover) {
    .link {
      cursor: pointer;
      transition: transform .2s ease-in-out;
      &:hover {
        transform: translateY(2px);
      }
    }
    .legend {
      cursor: pointer;
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
.main {
  .clothesMap {
    @media screen and (max-width: 830px) {
      .pc-only {
        display: none;
      }
    }
    @media screen and (min-width: 830px) {
      .map {
        margin-inline: 0;
      }
      .date {
        padding: min(.46vw, 5px) min(.92vw, 10px);
        p {
          font-size: min(1.84vw, 20px);
        }
      }
      .link {
        .area {
          padding: min(.46vw, 5px) min(.92vw, 10px);
          border-top-left-radius: min(1.2vw, 13px);
          border-bottom-left-radius: min(1.2vw, 13px);
          font-size: min(1.47vw, 16px);
        }
        .arrow {
          width: min(1.84vw, 20px);
          background-size: min(.92vw, 10px);
        }
        .balloon {
          top: max(-8.02vw, -87px);
          margin-left: max(-5.53vw, -60px);
          &::before {
            width: min(2.4vw, 26px);
            height: min(1.66vw, 18px);
          }
          .column {
            width: min(5.53vw, 60px);
          }
          .head {
            padding: min(.46vw, 5px) min(.18vw, 2px);
            gap: min(.18vw, 2px);
            height: min(2.49vw, 27px);
            span {
              font-size: min(1.11vw, 12px);
            }
          }
          .body {
            padding: min(.46vw, 5px) min(.74vw, 8px);
            height: min(4.42vw, 48px);
          }
        }
        // hokkaido
        &[data-area="hokkaido"] {
          top: 13%;
          right: 34%;
        }
        // douou
        &[data-area="douou"] {
          top: 50%;
          left: 34%;
        }
        &[data-area="sapporo"] {
          top: 51%;
          left: 34%;
        }
        &[data-area="suttsu"] {
          bottom: 19%;
          left: 16%;
        }
        &[data-area="fukagawa"] {
          top: 24%;
          right: 25%;
        }
        &[data-area="chitose"] {
          bottom: 3%;
          right: 43%;
        }
        &[data-area="iwamizawa"] {
          top: 56%;
          right: 32%;
        }
        // dounan
        &[data-area="dounan"] {
          top: 79%;
          left: 21%;
        }
        &[data-area="hakodate"] {
          bottom: 19%;
          left: 40%;
        }
        &[data-area="urakawa"] {
          bottom: 45%;
          right: 10%;
        }
        &[data-area="tomakomai"] {
          bottom: 66%;
          left: 53%;
        }
        &[data-area="esashi"] {
          bottom: 34%;
          left: 15%;
        }
        &[data-area="noboribetsu"] {
          bottom: 58%;
          left: 34%;
        }
        // douhoku
        &[data-area="douhoku"] {
          top: 17%;
          left: 39%;
        }
        &[data-area="asahikawa"] {
          bottom: 31%;
          left: 41%;
        }
        &[data-area="wakkanai"] {
          top: 26%;
          left: 43%;
        }
        &[data-area="rumoi"] {
          bottom: 38%;
          left: 21%;
        }
        &[data-area="furano"] {
          bottom: 5%;
          right: 28%;
        }
        &[data-area="nayoro"] {
          bottom: 42%;
          right: 26%;
        }
        // doutou
        &[data-area="doutou"] {
          top: 44%;
          right: 30%;
        }
        &[data-area="kushiro"] {
          bottom: 13%;
          right: 25%;
        }
        &[data-area="obihiro"] {
          bottom: 27%;
          left: 32%;
        }
        &[data-area="abashiri"] {
          top: 25%;
          right: 33%;
        }
        &[data-area="nemuro"] {
          top: 46%;
          right: 14%;
        }
        &[data-area="kitami"] {
          top: 32%;
          right: 54%;
        }
        // tohoku
        &[data-area="tohoku"] {
          top: 40%;
          right: 27%;
        }
        // aomori
        &[data-area="aomori"] {
          top: 19%;
          &:is([data-type="pref"] *) {
            top: auto;
            bottom: 35%;
            right: 40%;
          }
        }
        &[data-area="hirosaki"] {
          bottom: 27%;
          left: 28%;
        }
        &[data-area="hachinohe"] {
          bottom: 16%;
          right: 19%;
        }
        &[data-area="mutsu"] {
          top: 24%;
          right: 33%;
        }
        &[data-area="fukaura"] {
          bottom: 6%;
          left: 11%;
        }
        // akita
        &[data-area="akita"] {
          top: 41%;
          left: 40%;
          &:is([data-type="pref"] *) {
            top: 57%;
            left: 32%;
          }
        }
        &[data-area="odate"] {
          top: 24%;
          left: 47%;
        }
        &[data-area="yokote"] {
          bottom: 2%;
          right: 40%;
        }
        &[data-area="noshiro"] {
          top: 24%;
          left: 26%;
        }
        &[data-area="tazawako"] {
          bottom: 35%;
          right: 34%;
        }
        &[data-area="yurihonjo"] {
          bottom: 3%;
          left: 20%;
        }
        // iwate
        &[data-area="iwate"] {
          right: 31%;
        }
        &[data-area="morioka"] {
          top: 56%;
          left: 36%;
        }
        &[data-area="miyako"] {
          top: 47%;
          right: 26%;
        }
        &[data-area="ichinoseki"] {
          top: 89%;
          right: 46%;
        }
        &[data-area="ofunato"] {
          top: 80%;
          right: 24%;
        }
        &[data-area="ninohe"] {
          top: 24%;
          right: 43%;
        }
        // yamagata
        &[data-area="yamagata"] {
          top: 62%;
          left: 38%;
          &:is([data-type="pref"] *) {
            top: 65%;
            left: auto;
            right: 29%;
          }
        }
        &[data-area="sakata"] {
          top: 24%;
          left: 29%;
        }
        &[data-area="yonezawa"] {
          bottom: 3%;
          left: 42%;
        }
        &[data-area="shinjo"] {
          top: 30%;
          right: 35%;
        }
        &[data-area="sagae"] {
          top: 56%;
          left: 35%;
        }
        // miyagi
        &[data-area="miyagi"] {
          top: 59%;
          right: 36%;
        }
        &[data-area="sendai"] {
          top: 65%;
          left: 49%;
        }
        &[data-area="shiroishi"] {
          top: 86%;
          left: 29%;
        }
        &[data-area="kesennuma"] {
          top: 24%;
          right: 22%;
        }
        &[data-area="naruko"] {
          top: 31%;
          left: 40%;
        }
        &[data-area="ishinomaki"] {
          top: 58%;
          right: 15%;
        }
        // fukushima
        &[data-area="fukushima"] {
          bottom: 12%;
          left: 41%;
          &:is([data-type="pref"] *) {
            bottom: 67%;
            left: 53%;
          }
        }
        &[data-area="iwaki"] {
          bottom: 10%;
          right: 17%;
        }
        &[data-area="aizuwakamatsu"] {
          bottom: 38%;
          left: 31%;
        }
        &[data-area="koriyama"] {
          bottom: 34%;
          left: 53%;
        }
        &[data-area="hinoemata"] {
          bottom: 8%;
          left: 9%;
        }
        // kanto
        &[data-area="kanto"] {
          top: 61%;
          right: 30%;
        }
        // tokyo
        &[data-area="tokyo"] {
          &:is([data-type="area"] *) {
            top: 60%;
            left: 48%;
            right: auto;
          }
          &:is([data-type="pref"] *) {
            top: 54%;
            right: 5%;
          }
        }
        &[data-area="nerima"] {
          top: 24%;
          right: 30%;
        }
        &[data-area="hachiouji"] {
          top: 46%;
          left: 18%;
        }
        &[data-area="shinjuku"] {
          top: 56%;
          right: 28%;
        }
        &[data-area="tachikawa"] {
          top: 46%;
          left: 40%;
        }
        &[data-area="shinagawa"] {
          top: 89%;
          right: 21%;
        }
        // kanagawa
        &[data-area="kanagawa"] {
          top: 71%;
          left: 38%;
        }
        &[data-area="yokohama"] {
          top: 48%;
          right: 20%;
        }
        &[data-area="hakone"] {
          top: 72%;
          left: 16%;
        }
        &[data-area="atsugi"] {
          top: 46%;
          left: 34%;
        }
        &[data-area="noborito"] {
          top: 24%;
          left: 51%;
        }
        &[data-area="odawara"] {
          top: 79%;
          left: 35%;
        }
        // chiba
        &[data-area="chiba"] {
          top: 70%;
          right: 30%;
          &:is([data-type="pref"] *) {
            top: 50%;
            right: 55%;
          }
        }
        &[data-area="tateyama"] {
          bottom: 4%;
          right: 64%;
        }
        &[data-area="choshi"] {
          top: 37%;
          right: 14%;
        }
        &[data-area="narita"] {
          top: 25%;
          right: 37%;
        }
        &[data-area="katsuura"] {
          bottom: 19%;
          right: 29%;
        }
        // saitama
        &[data-area="saitama"] {
          top: 47%;
          left: 33%;
          &:is([data-type="pref"] *) {
            top: 63%;
            left: auto;
            right: 19%;
          }
        }
        &[data-area="chichibu"] {
          top: 57%;
          left: 15%;
        }
        &[data-area="kumagaya"] {
          top: 33%;
          right: 44%;
        }
        &[data-area="tokorozawa"] {
          bottom: 17%;
          right: 45%;
        }
        &[data-area="hanyu"] {
          top: 30%;
          right: 22%;
        }
        // tochigi
        &[data-area="tochigi"] {
          top: 19%;
          right: 41%;
        }
        &[data-area="utsunomiya"] {
          top: 60%;
          right: 43%;
        }
        &[data-area="nasushiobara"] {
          top: 26%;
          right: 30%;
        }
        &[data-area="nikko"] {
          top: 33%;
          left: 23%;
        }
        &[data-area="ashikaga"] {
          top: 84%;
          left: 25%;
        }
        &[data-area="moka"] {
          top: 72%;
          right: 23%;
        }
        // gunma
        &[data-area="gunma"] {
          top: 24%;
          left: 31%;
        }
        &[data-area="maebashi"] {
          top: 50%;
          left: 50%;
        }
        &[data-area="tatebayashi"] {
          top: 72%;
          right: 17%;
        }
        &[data-area="minakami"] {
          top: 25%;
          left: 27%
        }
        &[data-area="tsumagoi"] {
          top: 62%;
          left: 14%;
        }
        &[data-area="takasaki"] {
          top: 87%;
          left: 38%;
        }
        // ibaraki
        &[data-area="ibaraki"] {
          top: 41%;
          right: 33%;
        }
        &[data-area="mito"] {
          top: 45%;
          right: 28%;
        }
        &[data-area="daigo"] {
          top: 25%;
          left: 32%;
        }
        &[data-area="tsuchiura"] {
          top: 80%;
          left: 42%;
        }
        &[data-area="kashima"] {
          top: 85%;
          right: 23%;
        }
        &[data-area="koga"] {
          top: 62%;
          left: 19%;
        }
        // chubu
        &[data-area="chubu"] {
          top: 55%;
          left: 43%;
        }
        // aichi
        &[data-area="aichi"] {
          top: 70%;
          left: 42%;
        }
        &[data-area="nagoya"] {
          top: 62%;
          left: 23%;
        }
        &[data-area="toyohashi"] {
          bottom: 6%;
          right: 24%;
        }
        &[data-area="okazaki"] {
          top: 49%;
          left: 48%;
        }
        &[data-area="shinshiro"] {
          top: 46%;
          right: 17%;
        }
        &[data-area="ichinomiya"] {
          top: 26%;
          left: 19%;
        }
        // shizuoka
        &[data-area="shizuoka"] {
          top: 68%;
          right: 30%;
          &:is([data-type="pref"] *) {
            top: 51%;
            right: 47%;
          }
        }
        &[data-area="hamamatsu"] {
          top: 59%;
          left: 13%;
        }
        &[data-area="gotenba"] {
          top: 30%;
          right: 17%;
        }
        &[data-area="atami"] {
          top: 67%;
          right: 9%;
        }
        &[data-area="shimoda"] {
          bottom: 3%;
          right: 32%;
        }
        // gifu
        &[data-area="gifu"] {
          top: 54%;
          left: 37%;
          &:is([data-type="pref"] *) {
            top: 78%;
            left: 31%;
          }
        }
        &[data-area="takayama"] {
          top: 29%;
          right: 25%;
        }
        &[data-area="nakatsugawa"] {
          top: 67%;
          right: 13%;
        }
        &[data-area="gujo"] {
          top: 44%;
          left: 41%;
        }
        &[data-area="tajimi"] {
          top: 85%;
          right: 34%;
        }
        // yamanashi
        &[data-area="yamanashi"] {
          top: 55%;
          right: 32%;
        }
        &[data-area="kofu"] {
          top: 40%;
          right: 42%;
        }
        &[data-area="minobu"] {
          top: 74%;
          left: 28%;
        }
        &[data-area="otsuki"] {
          top: 42%;
          right: 21%;
        }
        &[data-area="fujiyohida"] {
          top: 77%;
          right: 31%;
        }
        &[data-area="hokuto"] {
          top: 32%;
          left: 24%;
        }
        // nagano
        &[data-area="nagano"] {
          top: 45%;
          left: 51%;
          &:is([data-type="pref"] *) {
            top: 27%;
            left: 40%;
          }
        }
        &[data-area="matsumoto"] {
          top: 53%;
          left: 20%;
        }
        &[data-area="iida"] {
          top: 89%;
          right: 58%;
        }
        &[data-area="karuizawa"] {
          top: 31%;
          right: 25%;
        }
        &[data-area="suwa"] {
          top: 65%;
          right: 40%;
        }
        // niigata
        &[data-area="niigata"] {
          top: 18%;
          right: 30%;
          &:is([data-type="pref"] *) {
            top: 52%;
            right: 35%;
          }
        }
        &[data-area="joetsu"] {
          top: 80%;
          left: 23%;
        }
        &[data-area="murakami"] {
          top: 25%;
          right: 15%;
        }
        &[data-area="sado"] {
          top: 27%;
          left: 30%;
        }
        &[data-area="yuzawa"] {
          top: 88%;
          right: 30%;
        }
        // toyama
        &[data-area="toyama"] {
          top: 33%;
          left: 46%;
          &:is([data-type="pref"] *) {
            top: 72%;
            left: 56%;
          }
        }
        &[data-area="himi"] {
          top: 27%;
          left: 23%;
        }
        &[data-area="tonami"] {
          top: 61%;
          left: 33%;
        }
        &[data-area="kurobe"] {
          top: 39%;
          right: 16%;
        }
        &[data-area="nanto"] {
          top: 87%;
          left: 16%;
        }
        // ishikawa
        &[data-area="ishikawa"] {
          top: 23%;
          left: 34%;
        }
        &[data-area="kanazawa"] {
          top: 57%;
          right: 41%;
        }
        &[data-area="wajima"] {
          top: 25%;
          left: 36%;
        }
        &[data-area="kaga"] {
          top: 81%;
          left: 23%;
        }
        &[data-area="hakusan"] {
          top: 89%;
          right: 36%;
        }
        &[data-area="nanao"] {
          top: 31%;
          right: 23%;
        }
        // fukui
        &[data-area="fukui"] {
          top: 43%;
          left: 28%;
          &:is([data-type="pref"] *) {
            top: 44%;
            left: 39%;
          }
        }
        &[data-area="tsuruga"] {
          top: 87%;
          left: 37%;
        }
        &[data-area="ono"] {
          top: 48%;
          right: 9%;
        }
        &[data-area="awara"] {
          top: 25%;
          right: 27%;
        }
        &[data-area="takahama"] {
          top: 77%;
          left: 10%;
        }
        // mie
        &[data-area="mie"] {
          top: 79%;
          left: 30%;
        }
        &[data-area="tsu"] {
          top: 58%;
          left: 53%;
        }
        &[data-area="yokkaichi"] {
          top: 25%;
          right: 22%;
        }
        &[data-area="owase"] {
          bottom: 18%;
          left: 31%;
        }
        &[data-area="ise"] {
          bottom: 11%;
          right: 18%;
        }
        &[data-area="iga"] {
          top: 35%;
          left: 34%;
        }
        // kinki
        &[data-area="kinki"] {
          top: 70%;
          left: 46%;
        }
        // osaka
        &[data-area="osaka"] {
          bottom: 46%;
          left: 38%;
          &:is([data-type="pref"] *) {
            bottom: 50%;
            left: 37%;
          }
        }
        &[data-area="hirakata"] {
          top: 28%;
          right: 30%;
        }
        &[data-area="kishiwada"] {
          bottom: 14%;
          left: 22%;
        }
        &[data-area="higashiosaka"] {
          top: 64%;
          right: 24%;
        }
        &[data-area="kawachinagano"] {
          bottom: 3%;
          left: 42%;
        }
        // kyoto
        &[data-area="kyoto"] {
          top: 18%;
          left: 42%;
          &:is([data-type="pref"] *) {
            top: 50%;
            left: 56%;
          }
        }
        &[data-area="maizuru"] {
          top: 26%;
          left: 37%;
        }
        &[data-area="uji"] {
          top: 86%;
          right: 27%;
        }
        &[data-area="fukuchiyama"] {
          top: 39%;
          left: 14%;
        }
        &[data-area="kameoka"] {
          top: 77%;
          left: 30%;
        }
        // hyogo
        &[data-area="hyogo"] {
          top: 29%;
          left: 29%;
        }
        &[data-area="kobe"] {
          top: 65%;
          right: 30%;
        }
        &[data-area="toyooka"] {
          top: 25%;
          right: 43%;
        }
        &[data-area="himeji"] {
          top: 57%;
          left: 29%;
        }
        &[data-area="takarazuka"] {
          top: 30%;
          right: 21%;
        }
        &[data-area="awaji"] {
          top: 91%;
          left: 35%;
        }
        // nara
        &[data-area="nara"] {
          bottom: 33%;
          left: 52%;
          &:is([data-type="pref"] *) {
            bottom: 67%;
            left: 49%;
          }
        }
        &[data-area="totsukawa"] {
          bottom: 5%;
          left: 24%;
        }
        &[data-area="yoshino"] {
          top: 59%;
          right: 42%;
        }
        &[data-area="kashihara"] {
          top: 36%;
          left: 28%;
        }
        &[data-area="oodaigahara"] {
          top: 86%;
          right: 23%;
        }
        // wakayama
        &[data-area="wakayama"] {
          bottom: 20%;
          left: 33%;
          &:is([data-type="pref"] *) {
            bottom: 65%;
            left: 19%;
          }
        }
        &[data-area="shingu"] {
          top: 84%;
          right: 22%;
        }
        &[data-area="shirahama"] {
          top: 84%;
          left: 27%;
        }
        &[data-area="hashimoto"] {
          top: 25%;
          left: 52%;
        }
        &[data-area="nakahechi"] {
          top: 61%;
          left: 45%;
        }
        // shiga
        &[data-area="shiga"] {
          top: 32%;
          right: 33%;
        }
        &[data-area="otsu"] {
          top: 60%;
          left: 23%;
        }
        &[data-area="hikone"] {
          top: 64%;
          right: 30%;
        }
        &[data-area="maibara"] {
          top: 29%;
          right: 31%;
        }
        &[data-area="koka"] {
          top: 89%;
          right: 47%;
        }
        &[data-area="nagahama"] {
          top: 25%;
          left: 35%;
        }
        // chugoku
        &[data-area="chugoku"] {
          top: 63%;
          left: 29%;
        }
        // hiroshima
        &[data-area="hiroshima"] {
          top: 68%;
          left: 42%;
          &:is([data-type="pref"] *) {
            top: 68%;
            left: 18%;
          }
        }
        &[data-area="shobara"] {
          top: 26%;
          right: 22%;
        }
        &[data-area="onomichi"] {
          top: 69%;
          right: 21%;
        }
        &[data-area="akitakata"] {
          top: 34%;
          left: 38%;
        }
        &[data-area="higashihiroshima"] {
          top: 71%;
          right: 47%;
        }
        // okayama
        &[data-area="okayama"] {
          right: 29%;
          &:is([data-type="pref"] *) {
            top: 62%;
            right: 44%;
          }
        }
        &[data-area="tsuyama"] {
          top: 26%;
          right: 35%;
        }
        &[data-area="niimi"] {
          top: 31%;
          left: 25%;
        }
        &[data-area="kurashiki"] {
          top: 84%;
          left: 28%;
        }
        &[data-area="bizen"] {
          top: 59%;
          right: 23%;
        }
        // tottori
        &[data-area="tottori"] {
          top: 35%;
          right: 24%;
          &:is([data-type="pref"] *) {
            top: 42%;
            right: 23%;
          }
        }
        &[data-area="yonago"] {
          top: 33%;
          left: 19%;
        }
        &[data-area="kurayoshi"] {
          top: 55%;
          left: 39%;
        }
        &[data-area="nichinan"] {
          top: 87%;
          left: 10%;
        }
        &[data-area="chizu"] {
          top: 80%;
          right: 14%;
        }
        // shimane
        &[data-area="shimane"] {
          top: 44%;
          left: 35%;
        }
        &[data-area="matsue"] {
          top: 43%;
          right: 24%;
        }
        &[data-area="hamada"] {
          top: 65%;
          left: 31%;
        }
        &[data-area="oki"] {
          top: 25%;
          left: 40%;
        }
        &[data-area="tsuwano"] {
          bottom: 5%;
          left: 13%;
        }
        &[data-area="izumo"] {
          top: 77%;
          left: 52%;
        }
        // yamaguchi
        &[data-area="yamaguchi"] {
          top: 73%;
          left: 14%;
          &:is([data-type="pref"] *) {
            top: 58%;
            left: 33%;
          }
        }
        &[data-area="hagi"] {
          top: 25%;
          left: 41%;
        }
        &[data-area="shimonoseki"] {
          top: 62%;
          left: 8%;
        }
        &[data-area="yanai"] {
          top: 74%;
          right: 18%;
        }
        &[data-area="iwakuni"] {
          top: 42%;
          right: 23%;
        }
        // shikoku
        &[data-area="shikoku"] {
          top: 79%;
          left: 33%;
        }
        // ehime
        &[data-area="ehime"] {
          top: 41%;
          left: 25%;
        }
        &[data-area="matsuyama"] {
          top: 32%;
          left: 41%;
        }
        &[data-area="uwajima"] {
          top: 86%;
          left: 22%;
        }
        &[data-area="niihama"] {
          top: 30%;
          right: 20%;
        }
        &[data-area="kumakogen"] {
          top: 65%;
          right: 29%;
        }
        &[data-area="yawatahama"] {
          top: 48%;
          left: 18%;
        }
        // kagawa
        &[data-area="kagawa"] {
          top: 21%;
          right: 34%;
        }
        &[data-area="takamatsu"] {
          top: 67%;
          right: 42%;
        }
        &[data-area="kotohira"] {
          top: 81%;
          left: 12%;
        }
        &[data-area="shodoshima"] {
          top: 27%;
          right: 33%;
        }
        &[data-area="marugame"] {
          top: 35%;
          left: 23%;
        }
        &[data-area="higashikagawa"] {
          top: 77%;
          right: 6%;
        }
        // tokushima
        &[data-area="tokushima"] {
          top: 36%;
          right: 28%;
          &:is([data-type="pref"] *) {
            top: 59%;
            right: 17%;
          }
        }
        &[data-area="minami"] {
          top: 83%;
          right: 35%;
        }
        &[data-area="mima"] {
          top: 36%;
          left: 42%;
        }
        &[data-area="naruto"] {
          top: 25%;
          right: 16%;
        }
        &[data-area="iya"] {
          top: 60%;
          left: 22%;
        }
        // kouchi
        &[data-area="kouchi"] {
          top: 53%;
          left: 37%;
          &:is([data-type="pref"] *) {
            top: 48%;
            left: 46%;
          }
        }
        &[data-area="sukumo"] {
          top: 63%;
          left: 14%;
        }
        &[data-area="muroto"] {
          top: 65%;
          right: 10%;
        }
        &[data-area="motoyama"] {
          top: 25%;
          left: 63%;
        }
        &[data-area="tosashimizu"] {
          top: 89%;
          left: 29%;
        }
        // kyushu
        &[data-area="kyushu"] {
          top: 79%;
          left: 18%;
        }
        // fukuoka
        &[data-area="fukuoka"] {
          top: 20%;
          right: 38%;
          &:is([data-type="pref"] *) {
            top: 29%;
            right: 53%;
          }
        }
        &[data-area="kokura"] {
          top: 25%;
          right: 18%;
        }
        &[data-area="kurume"] {
          top: 63%;
          left: 26%;
        }
        &[data-area="iizuka"] {
          top: 53%;
          left: 52%;
        }
        &[data-area="omuta"] {
          bottom: 4%;
          left: 45%;
        }
        // saga
        &[data-area="saga"] {
          top: 24%;
          left: 39%;
          &:is([data-type="pref"] *) {
            top: 46%;
            left: 53%;
          }
        }
        &[data-area="karatsu"] {
          top: 32%;
          left: 32%;
        }
        &[data-area="imari"] {
          top: 66%;
          left: 19%;
        }
        &[data-area="tosu"] {
          top: 49%;
          right: 11%;
        }
        &[data-area="kashima_saga"] {
          top: 87%;
          left: 41%;
        }
        // nagasaki
        &[data-area="nagasaki"] {
          top: 35%;
          left: 32%;
          &:is([data-type="pref"] *) {
            top: 85%;
            left: 30%;
          }
        }
        &[data-area="sasebo"] {
          top: 50%;
          right: 41%;
        }
        &[data-area="tsushima"] {
          top: 25%;
          left: 21%;
        }
        &[data-area="shimabara"] {
          bottom: 3%;
          right: 28%;
        }
        &[data-area="fukue"] {
          bottom: 10%;
          left: 5%;
        }
        // oita
        &[data-area="oita"] {
          top: 36%;
          right: 31%;
          &:is([data-type="pref"] *) {
            top: 44%;
            right: 29%;
          }
        }
        &[data-area="hita"] {
          top: 55%;
          left: 14%;
        }
        &[data-area="saiki"] {
          bottom: 8%;
          right: 27%;
        }
        &[data-area="bungotakada"] {
          top: 25%;
          right: 48%;
        }
        &[data-area="yufuin"] {
          top: 59%;
          right: 49%;
        }
        // kumamoto
        &[data-area="kumamoto"] {
          top: 46%;
          left: 42%;
          &:is([data-type="pref"] *) {
            top: 53%;
            left: 41%;
          }
        }
        &[data-area="amakusa"] {
          top: 68%;
          left: 15%;
        }
        &[data-area="hitoyoshi"] {
          bottom: 3%;
          right: 43%;
        }
        &[data-area="aso"] {
          top: 28%;
          right: 29%;
        }
        &[data-area="tamana"] {
          top: 25%;
          left: 23%;
        }
        // miyazaki
        &[data-area="miyazaki"] {
          top: 55%;
          right: 34%;
          &:is([data-type="pref"] *) {
            top: 77%;
            right: 31%;
          }
        }
        &[data-area="nobeoka"] {
          top: 28%;
          right: 22%;
        }
        &[data-area="takachiho"] {
          top: 25%;
          left: 39%;
        }
        &[data-area="miyakonojo"] {
          top: 83%;
          left: 33%;
        }
        &[data-area="ebino"] {
          top: 48%;
          left: 20%;
        }
        // kagoshima
        &[data-area="kagoshima"] {
          top: 63%;
          left: 33%;
          &:is([data-type="pref"] *) {
            top: 70%;
            left: 31%;
          }
        }
        &[data-area="kanoya"] {
          top: 71%;
          right: 29%;
        }
        &[data-area="amami"] {
          bottom: 5%;
          left: 5%;
        }
        &[data-area="tanegashima"] {
          top: 25%;
          left: 24%;
        }
        &[data-area="satsumasendai"] {
          top: 35%;
          left: 45%;
        }
        // okinawa
        // &[data-area="okinawa"] {
        //   top: 43%;
        //   left: 48%;
        // }
        &[data-area="naha"] {
          top: 44%;
          left: 47%;
        }
        &[data-area="nago"] {
          top: 48%;
          right: 18%;
        }
        &[data-area="miyakojima"] {
          top: 77%;
          left: 34%;
        }
        &[data-area="ishigaki"] {
          top: 67%;
          left: 12%;
        }
      }
    }
  }
}
</style>
